module.exports = __webpack_public_path__ + "media/images/Waterfall-881fc83a.webp";